import { right } from 'fp-ts/lib/Either';

import { httpClientFunction } from 'domain/types';
import PreviewAnalysisClient from 'use-case/analysis/data/preview/previewAnalysisDataClient';
import { asWidgetData, asWidgetDataError } from 'adapter/out/client/widgets/data/readWidgetDataApiClient';
import AnalysisDataCriteria from 'use-case/analysis/analysisCriteria';
import { asTimeseries } from 'adapter/out/client/widgets/data/mappers/TimeseriesMapper';
import { VISUALISATION_TYPE } from 'domain/entity/analysis';
import { parseAnalysisDataCriteria } from 'adapter/out/client/analysis/parseAnalysis';

const previewAnalysisDataApiClient = (httpClient: httpClientFunction, baseUrl: string): PreviewAnalysisClient => (
    criteria: AnalysisDataCriteria
) =>
    httpClient(
        `${baseUrl}/dashboards/analyses/${criteria.analysisId}/data?timeshift=${mapTimeShift(criteria.timeShifts)}&saveChanges=${
            criteria.saveChanges
        }`,
        {
            method: 'POST',
            body: JSON.stringify(parseAnalysisDataCriteria(criteria)),
            headers: { 'Content-Type': 'application/json' },
        }
    )
        .then(async (response) =>
            response.ok
                ? response
                      .json()
                      .then((json) =>
                          criteria.visualisation.type === VISUALISATION_TYPE.RAW
                              ? asTimeseries(json)
                              : { ...asWidgetData(json), magnitudes: json.magnitudes }
                      )
                      .then(right)
                      .catch((error: Error) => asWidgetDataError(error, 500))
                : asWidgetDataError(await response.json(), response.status)
        )
        .catch((error: Error) => asWidgetDataError(error, 500));
const mapTimeShift = (timeshifts: number) => {
    if (Math.sign(timeshifts) === 0) {
        return 'NO_SHIFT';
    }
    return Math.sign(timeshifts) === -1 ? `SHIFT_${Math.abs(timeshifts)}_PERIOD_BEFORE` : `SHIFT_${Math.abs(timeshifts)}_PERIOD_AFTER`;
};

export default previewAnalysisDataApiClient;
